<template>
    <div class="reason-container">
        <div class="des">{{$t('logout.LeavingHiLeiaMessage')}}</div>
        <div class="input-container">
            <a-checkbox-group v-model="checkboxList" class="reason-checkbox-group">
                <a-row>
                    <a-col :span="12">
                        <a-checkbox value="安全/隐私问题">
                            {{$t('logout.SecurityPrivacyIssues')}}
                        </a-checkbox>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-checkbox value="无法解决场景问题">
                            {{$t('logout.NotResolveIssues')}}
                        </a-checkbox>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-checkbox value="产品使用体验差">
                            {{$t('logout.BadExperience')}}
                        </a-checkbox>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-checkbox value="费用过高">
                            {{$t('logout.ExcessiveCost')}}
                        </a-checkbox>
                    </a-col>
                </a-row>
            </a-checkbox-group>
            <a-textarea
                v-model="textareaVal"
                class="reason-textarea"
                :placeholder="$t('logout.TallSuggestAndProblem')"
                :maxLength="100"
            ></a-textarea>
        </div>
        <BasicBtnGroup
            :showDef="false"
            @primeClick="confirm"
            class="reason-confirm-btn"
        >
            <span slot="primaryContent">{{$t('logout.Continue')}}</span>
        </BasicBtnGroup>
    </div>
</template>
<script>
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'

export default {
  name: 'CancelAccountReason',
  components: {
    BasicBtnGroup
  },
  data() {
    return {
      checkboxList: [],
      textareaVal: ''
    }
  },
  methods: {
    confirm() {
      this.$emit('handleReason', { checkboxList: this.checkboxList, textarea: this.textareaVal })
    }
  }
}
</script>
<style scoped lang="less">
.reason-container {
    padding: 32px 56px 0;
    .des {
        font-size: 16px;
        font-weight: 400;
        color: #6A6D73;
        margin-bottom: 24px;
    }
    .input-container {
        position: relative;
        .reason-textarea {
            position: absolute;
            width: 372px;
            height: 120px;
            top: 0;
            right: 0;
            box-shadow: inset 0px 0px 10px 0px rgba(151, 171, 199, 0.15);
            border-radius: 8px;
        }
    }
    .reason-confirm-btn {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-top: 27px;
    }
    .reason-checkbox-group {
        width: 100%;
        .ant-row {
            margin-bottom: 17px;
        }
    }
}

</style>
